export class TabError {
  tabName!: string;
  tabError!: string;
}
